// extracted by mini-css-extract-plugin
module.exports = {"dateFieldInput":"DeliveryPointDetails_dateFieldInput__3v2O9"};